import { render, staticRenderFns } from "./approve-education.vue?vue&type=template&id=60ef521a&"
import script from "./approve-education.vue?vue&type=script&lang=js&"
export * from "./approve-education.vue?vue&type=script&lang=js&"
import style0 from "./approve-education.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports